import gql from 'graphql-tag'

export default gql`
  fragment OpenGraphContent on OpenGraph {
    siteName
    type
    title
    description
    imageURL
  }
`
